module.exports = __webpack_public_path__ + "img/v_delete.a5427dc7.svg";